import { useMemo } from 'react';
import { keyBy } from 'lodash';
import { FORM_MODES } from 'config/formModes';
import { useAvailableItems, useFormMode } from 'hooks';
import { BID_STRATEGIES } from 'modules/campaigns/modules/common-campaign-form/config';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { bidStrategiesCategory } from './useBidStrategiesOptions';
import { useBidStrategyValidatedFormValue } from './useBidStrategyValidatedFormValue';
import { useTargetCpaAvailability } from './useTargetCpaAvailability';

const bidStrategiesOptions = [
    {
        id: BID_STRATEGIES.TARGET_CPA,
        visibilityCondition: ({ shouldRenderTargetCpa }) => shouldRenderTargetCpa,
    },
    {
        id: bidStrategiesCategory.MAX_CONVERSIONS,
        accountConfigurations: { [FEATURE_FLAGS.MAX_CONVERSIONS_ENABLED]: 'true' },
    },
    {
        id: BID_STRATEGIES.TARGET_ROAS,
        accountConfigurations: { [FEATURE_FLAGS.TARGET_ROAS_ENABLED]: 'true' },
    },
    {
        id: BID_STRATEGIES.MAX_VALUE,
        accountConfigurations: { [FEATURE_FLAGS.MAX_VALUE_ENABLED]: 'true' },
    },
    {
        id: BID_STRATEGIES.SMART,
    },
    {
        id: BID_STRATEGIES.FIXED,
    },
    {
        id: BID_STRATEGIES.BID_MODIFIER,
        visibilityCondition: ({ formMode }) => formMode === FORM_MODES.BULK_EDIT,
    },
];

export const useBidStrategyState = () => {
    const {
        value: bidStrategy,
        onChange: onChangeBidStrategy,
        indicationData,
        scrollRef,
    } = useBidStrategyValidatedFormValue();
    const formMode = useFormMode();
    const { shouldRenderTargetCpa } = useTargetCpaAvailability();
    const availableItems = useAvailableItems(bidStrategiesOptions, { shouldRenderTargetCpa, formMode });
    const availableBidStrategies = useMemo(() => keyBy(availableItems, 'id'), [availableItems]);

    return {
        indicationData,
        scrollRef,
        bidStrategy,
        onChangeBidStrategy,
        availableBidStrategies,
    };
};
